<template>
	<div class="info-status">
		<div v-if="statusSlug?.includes('new') || statusSlug === 'revision.for_operator' || statusSlug === 'review' || statusSlug === 'refusal.processing'" class="info-status__item">
			<template v-if="(newYearDay || holiday || holidayDays)">
				<img v-if="(!workTime || holiday)" class="info-status__img" src="images/new-year/sleepOrHoliday.svg" alt="Новогодние праздники или спим"/>
				<img v-else class="info-status__img" src="./images/new-year/new.svg" alt="Новогодняя новая заявка"/>
			</template>
			<template v-else>
				<img v-if="workTime" class="info-status__img" src="./images/new.svg" alt="Новая заявка"/>
				<img v-else class="info-status__img" src="./images/sleep.svg" alt="Спим"/>
			</template>

			<h1 class="info-status__headline">Спасибо за заявку</h1>
			<template v-if="(newYearDay || holiday || holidayDays)">
				<p v-if="(!workTime || holiday)" class="info-status__text">
					<span style="margin-bottom: 8px; display: inline-block">Кредитный сервис Incognito поздравляет вас с Новым Годом! Желаем счастья, здоровья и процветания!</span>
					Мы получили вашу заявку и обязательно обработаем ее в рабочее время. В праздничные дни мы работаем со 2 по 9 января с 9:00 до 18:00.
				</p>
				<p v-else class="info-status__text">
					<span style="margin-bottom: 8px; display: inline-block">Кредитный сервис Incognito поздравляет вас с Новым Годом! Желаем счастья, здоровья и процветания!</span>
					Мы получили Вашу заявку и обязательно свяжемся с Вами в течение нескольких минут.
				</p>
			</template>
			<template v-else>
				<div v-if="workTime" class="info-status__text">
					Для уточнения информации по заявке <br>
					Вам может поступить звонок с номера <br>
					<a href="tel:+73472009954" class="info-status__phone">8 (347) 200-99-54</a>
					<div>Пожалуйста, добавьте номер телефона в список контактов. <br> Мы с него будем вам звонить </div>
				</div>
				<div v-else class="info-status__text">
					К сожалению, сейчас мы спим. <br> Мы обработаем вашу заявку в рабочее время. <br> График работы: пн - пт: 09:00-18:00
				</div>
			</template>
		</div>

		<div v-else-if="statusSlug === 'refusal' || statusSlug === 'refusal.doubtful' || statusSlug === 'closed.without_verification'" class="info-status__item">
			<img class="info-status__img" src="./images/refusal.svg" alt="Отказ"/>
			<h1 class="info-status__headline">По вашей заявке пришел отказ</h1>
			<p class="info-status__text">Попробуйте отправить заявку снова через пару недель</p>
		</div>

		<div v-else-if="statusSlug === 'approved'" class="info-status__item info-status__approved">
			<img class="info-status__img" src="./images/approved.svg" alt="Одобрено"/>
			<h1 class="info-status__headline">Ваша заявка одобрена</h1>
			<p class="info-status__text">Осталось подписать договор и получить деньги на карту </p>
			<Button :handler="goToApproved" class="button--info-status-approved button">Получить деньги</Button>
		</div>

		<div v-else-if="statusSlug === 'money_transfer'" class="info-status__item">
			<img class="info-status__img" src="./images/money-transfer.svg" alt="Отправка денег на карту"/>
			<h1 class="info-status__headline">Отправляем деньги на вашу карту</h1>
			<p class="info-status__text">Договор успешно подписан. <br> Ожидайте поступления денежных средств в течение пары минут </p>
		</div>
	</div>
</template>

<script setup>
import {
	computed, ref, watch,
} from 'vue';
import Button from '@/shared/components/Button/Button.vue';
import { useStore } from 'vuex';
import { useStorage } from '@vueuse/core';
import { useRouter } from 'vue-router';
import { getTimeInTimeZone } from '@/shared/lib/helpers/time';

const store = useStore();
const router = useRouter();
const currentTimeInTimeZone = getTimeInTimeZone(5);
const newYearDay = currentTimeInTimeZone.getFullYear() === 2023 && currentTimeInTimeZone.getMonth() === 11 && currentTimeInTimeZone.getDate() === 31;
const holidayDays = currentTimeInTimeZone.getFullYear() === 2024 && currentTimeInTimeZone.getMonth() === 0 && (currentTimeInTimeZone.getDate() >= 2 && currentTimeInTimeZone.getDate() <= 8);
const holiday = currentTimeInTimeZone.getFullYear() === 2024 && currentTimeInTimeZone.getMonth() === 0 && currentTimeInTimeZone.getDate() === 1;

const workTime = computed(() => {
	if (newYearDay || holidayDays) {
		return currentTimeInTimeZone.getHours() >= 9 && currentTimeInTimeZone.getHours() < 18;
	}

	const saturday = currentTimeInTimeZone.getDay() === 6;
	const sunday = currentTimeInTimeZone.getDay() === 0;
	const weekdaysWorktime = !saturday && !sunday && (currentTimeInTimeZone.getHours() >= 9 && currentTimeInTimeZone.getHours() < 18);
	// const weekendWorktime = (saturday || sunday) && (currentTimeInTimeZone.getHours() >= 10 && currentTimeInTimeZone.getHours() < 16);
	// return weekdaysWorktime || weekendWorktime;
	return weekdaysWorktime;
});

const statusSlug = ref(null);

const msg = useStorage('payout_message');

watch([() => store.state.centrifugeStatus.loanStatus, () => store.state.centrifugeStatus.payoutStatus.status], (val) => {
	const [loanStatus, payoutStatus] = val;

	if (payoutStatus === null) {
		statusSlug.value = loanStatus;
		console.log('INFOSTATUS LOAN:', statusSlug.value);
		const ignoredStatuses = ['created', 'closed', 'closed.without_verification', 'contract_signed'];
		if (!statusSlug.value || ignoredStatuses.includes(statusSlug.value)) {
			window.location.href = '/';
		}
	} else {
		switch (payoutStatus) {
		case true:
			window.location.href = '/main-page';
			msg.value = null;
			break;
		case false:
			msg.value = store.state.centrifugeStatus.payoutStatus.errorMessage;
			// window.location.href = '/payout-status';
			router.push({ name: 'payout-status' });
			break;
		default:
			break;
		}
	}
}, { immediate: true });

function goToApproved() {
	console.log('123');
	router.push({ name: 'approved' });
}

// eslint-disable-next-line no-unused-vars
async function confirmReject() {
	try {
		const response = await store.dispatch('infoStatus/confirmRejection');
		console.log('confirmReject response:', response);
	} catch (e) {
		console.log('conffirmRejection Error:', e);
	} finally {
		window.location.href = '/';
	}
}

</script>

<style lang="scss" scoped>
@import "info-status";
</style>
